// 版本配置
// 部署时由 deploy.sh 自动更新 APP_VERSION，强制用户重新登录获取最新版本
// 请勿手动修改 APP_VERSION，它会在每次部署时被自动替换

export const APP_VERSION = '2.1104.1215';
export const APP_NAME = '出团管理系统';
export const VERSION_KEY = 'passport_app_version';

// 检查版本是否需要更新
export const checkVersionUpdate = () => {
  const storedVersion = localStorage.getItem(VERSION_KEY);
  if (storedVersion !== APP_VERSION) {
    return true; // 版本不一致，需要更新
  }
  return false;
};

// 保存当前版本到本地存储
export const saveVersion = () => {
  localStorage.setItem(VERSION_KEY, APP_VERSION);
};

// 清除版本记录（用于强制重新登录）
export const clearVersion = () => {
  localStorage.removeItem(VERSION_KEY);
};
